import { render, staticRenderFns } from "./Interessi.vue?vue&type=template&id=71f8ddcf"
import script from "./Interessi.vue?vue&type=script&lang=js"
export * from "./Interessi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports